import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { AdacCheckbox } from '@adac-de/component-library';
import { PartnerCheckbox } from '../inputs/partner-checkbox';
import { Partners } from '../../../types';
import styles from './partner-selection.module.scss';
import { PARTNER_ERROR } from './form-variables';
import { ErrorText } from '@components/error/error-text';
import { ErrorWrapper } from '@components/error/error-wrapper';

export type PartnerSelectionFormFields = {
  partners: Partners[];
  allPartners: boolean;
};

type PartnerSelectionProps = {
  partnerBoxes: PartnerBox[];
  partnerNames?: Partners[];
};

export const PartnerSelection: React.FC<PartnerSelectionProps> = ({
  partnerNames,
  partnerBoxes
}) => {
  const {
    setValue,
    control,
    formState: { errors },
    clearErrors,
    watch,
    register
  } = useFormContext<PartnerSelectionFormFields>();

  const selectedPartners = useWatch<PartnerSelectionFormFields, 'partners'>({
    control,
    name: 'partners'
  });

  const isAllSelected =
    selectedPartners.every(partner => partnerNames?.includes(partner)) &&
    selectedPartners.length === partnerNames?.length;

  const toggleSelectAllCheckbox = () => {
    if (partnerNames === undefined) {
      return;
    }

    setValue('partners', [...(isAllSelected ? [] : partnerNames)], {});
    if (watch('allPartners')) {
      clearErrors('partners');
    }
  };

  useEffect(() => {
    if (!isAllSelected) {
      setValue('allPartners', false);
    }
  }, [isAllSelected]);

  return (
    <ErrorWrapper aria-labelledby="partner-headline">
      <div className={styles.selectAll}>
        <AdacCheckbox
          label="Alle auswählen"
          checked={isAllSelected}
          {...register('allPartners', { onChange: toggleSelectAllCheckbox })}
        />
      </div>

      {partnerBoxes.map((box, index) => (
        <PartnerCheckbox
          box={box}
          key={`${box.partner}-${index}`}
          error={Boolean(errors.partners)}
        />
      ))}

      {errors.partners && <ErrorText text={PARTNER_ERROR} className={styles.partnerSectionError} />}
    </ErrorWrapper>
  );
};
